import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  // Hidden until authentic MATTE KLAR reviews are added in data/content.ts
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-271" data-mp="3fyw1ajdmptfb">
      <div className="mx-auto max-w-6xl" data-id="element-272" data-mp="3azjdnwexoibo">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-273" data-mp="3ayhx5cf5f3mk">
          <em className="text-red-700" data-id="element-274" data-mp="36wmqrtid201x">老師</em>怎樣說
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-275" data-mp="31ybe7b0olbg0">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-276" data-mp="2x2w3grxyzvnt">
              <div className="text-sm text-amber-500" aria-label="五星評分" data-id="element-277" data-mp="2s308tjb5xgkx">
                <span aria-hidden="true" data-id="element-278" data-mp="v9ydd3vkvh6k">★★★★★</span>
              </div>
              <blockquote className="mt-4 flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-279" data-mp="qac2v274wf1g">
                ”{item.quote}”
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-280" data-mp="h4dc6jitvk34">
                <span className="font-semibold text-slate-900" data-id="element-281" data-mp="m4rnqbjn1c5w">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-282" data-mp="m2ood0wli6oi"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}